import { Component, inject, input } from '@angular/core';

import { WebsiteService } from '../../service/website.service';

const TIKTOK_PATH = 'M448.5 209.9c-44 .1-87-13.6-122.8-39.2l0 178.7c0 33.1-10.1 65.4-29 92.6s-45.6 48-76.6'
  + ' 59.6-64.8 13.5-96.9 5.3-60.9-25.9-82.7-50.8-35.3-56-39-88.9 2.9-66.1 18.6-95.2 40-52.7 69.6-67.7 62.9-20.5'
  + ' 95.7-16l0 89.9c-15-4.7-31.1-4.6-46 .4s-27.9 14.6-37 27.3-14 28.1-13.9 43.9 5.2 31 14.5 43.7 22.4 22.1 37.4'
  + ' 26.9 31.1 4.8 46-.1 28-14.4 37.2-27.1 14.2-28.1 14.2-43.8l0-349.4 88 0c-.1 7.4 .6 14.9 1.9 22.2 3.1 16.3'
  + ' 9.4 31.9 18.7 45.7s21.3 25.6 35.2 34.6c19.9 13.1 43.2 20.1 67 20.1l0 87.4z';

/**
 * The `social` and `social-topbar` partials: the same list of networks, only the classes differ.
 */
@Component({
  selector: 'social',
  template: `
    @if (website().facebookUrl) {
      <a target="_blank" aria-label="Facebook" [href]="website().facebookUrl"
        [class]="itemClass() + ' fa-facebook'"></a>
    }
    @if (website().instagramUrl) {
      <a target="_blank" aria-label="Instagram" [href]="website().instagramUrl"
        [class]="itemClass() + ' fa-instagram'"></a>
    }
    @if (website().pinterestUrl) {
      <a target="_blank" aria-label="Pinterest" [href]="website().pinterestUrl"
        [class]="itemClass() + ' fa-pinterest-p'"></a>
    }
    @if (website().snapchatUrl) {
      <a target="_blank" aria-label="Snapchat" [href]="website().snapchatUrl"
        [class]="itemClass() + ' fa-snapchat-ghost'"></a>
    }
    @if (website().youtubeUrl) {
      <a target="_blank" aria-label="YouTube" [href]="website().youtubeUrl"
        [class]="itemClass() + ' fa-youtube-play'"></a>
    }
    @if (website().tiktokUrl) {
      <a target="_blank" aria-label="TikTok" [href]="website().tiktokUrl" [class]="itemClass()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path [attr.d]="tiktokPath"/>
        </svg>
      </a>
    }
    `
})
export class SocialComponent {

  /** 'topbar-social-item fa' in the topbar, 'fs-18 color1 p-r-20 fa' in the footer and contacts. */
  readonly itemClass = input('fs-18 color1 p-r-20 fa');

  readonly tiktokPath = TIKTOK_PATH;
  readonly website = inject(WebsiteService).current;

}
